import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { IconComponent } from '../icon/icon.component';



export interface ProfileImageConfig {
  placeholder?: string;
  menu?: boolean; // if true - then show burger icon (instead of placeholder) when no image
  image?: string;
  size?: number;
  borderWidth?: number;
  textClasses?: string;
}

@Component({
    selector: 'app-profile-image',
    imports: [CommonModule, NgOptimizedImage, IconComponent],
    templateUrl: './profile-image.component.html',
    styleUrl: './profile-image.component.scss'
})
export class ProfileImageComponent {
  configuration: ProfileImageConfig;

  @Input()
  set config(value: ProfileImageConfig) {
    if (value) {
      this.configuration = { ...value };
    }
  }
  get config(): ProfileImageConfig {
    return this.configuration;
  }

}
